var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated"},[(_vm.sample_collection)?_c('SampleServerTable',{attrs:{"collection":_vm.sample_collection}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }